import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { InsightsModel } from '../models/common.model';

@Injectable({
  providedIn: 'root'
})
export class InsightspopupService {
  insightsopen : boolean = false;
  private isInsights = new BehaviorSubject<InsightsModel>({
    header: 'Insights',
    message: '',
    show: false,
  });
  isInsights$ = this.isInsights.asObservable();
  /**
   * show the loader icon
   */
  showInisghts(InsightsMessage: InsightsModel): void {
    this.isInsights.next(InsightsMessage);
  }


  private isInsightsSnapshot = new BehaviorSubject<InsightsModel>({
    header: 'Insights',
    message: '',
    show: false,
  });
  isInsightsSnapshot$ = this.isInsightsSnapshot.asObservable();
  public isSingleInsightsSnapshot$ = new BehaviorSubject<any>(null);
  /**
   * show the loader icon
   */
  showInisghtsSnapshot(InsightsMessage: InsightsModel): void {
    this.isInsightsSnapshot.next(InsightsMessage);
  }
}
